import React, { useState, useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCloudDownload, faSearch } from "@fortawesome/pro-light-svg-icons";
import ScrollTable from "./../../../components/ScrollTable/index";
import { LoaderWrapper } from "../../../components";
import * as fileSaver from "file-saver";
import { CSVLink, CSVDownload } from "react-csv";
import XLSX from "sheetjs-style";
import { manageMapperStore } from "../../../contexts";
import { get, isEmpty, toLower } from "lodash";
import {
  passthroughStringToFunctionConverter,
  removePassthroughFieldTrans,
  stringToFunctionConverter,
} from "../../../utils";

const VerifyMapExcelOutputContainer = ({ arrayObject, fileName, mapType }) => {
  const { state, dispatch } = useContext(manageMapperStore);
  var sourceData =
    !isEmpty(get(state, "api.data.headerMapJson")) &&
    JSON.parse(get(state, "api.data.headerMapJson"));
  var outputFileFormat = get(state, "api.data.format");
  var passthroughFileFormat = get(state, "api.data.targetFileFormat");
  var fileFormat = mapType == 3 ? passthroughFileFormat : outputFileFormat;
  var fileFormatExtenstion = fileFormat === 1 ? ".csv" : ".xlsx";
  var contentStartsFromRow =
    get(state, "api.data.targetFileContentStartsFromRow") ??
    get(state, "api.data.contentStartsFromRow");
  var content = "A" + contentStartsFromRow;
  var objForCSV = {};
  arrayObject.map((it) => {
    objForCSV[it.header] = it.value;
  });

  const fileTypeExcel =
    "application/vnd.openxmlformats-officedocuments.spreadsheetml.sheet;charset=UTF-8";
  const fileTypeCSV = "data:text/csv;charset=utf-8,${csv}`";
  const fileExtenstion = ".xlsx";

  const exportToExcel = async () => {
    var obj = {};
    if (mapType == 3) {
      arrayObject.map((it, ind) => {
        obj[it.Header] = passthroughStringToFunctionConverter(
          it.PropertyName,
          sourceData,
          1
        );
      });
    } else {
      arrayObject.map((it, ind) => {
        obj[it.headerValue] = stringToFunctionConverter(it?.value, 3);
      });
    }
    let ws = XLSX.utils.json_to_sheet([obj], { origin: content });
    let wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileTypeExcel });
    fileSaver.saveAs(
      data,
      stringToFunctionConverter(fileName, 2).concat(".xlsx")
    );
  };

  // const exportToCSV = async () => {
  //   var obj = {};
  //   arrayObject.map((it, ind) => {
  //     obj[it.header] = it.value;
  //   });
  //   var ws = XLSX.utils.json_to_sheet([obj],{ origin: "A7" } );
  //   var csv = XLSX.utils.sheet_to_csv(ws,{FS: ';'},);
  //   function s2ab(s) {
  //     var buf = new ArrayBuffer(s.length);
  //     var view = new Uint8Array(buf);
  //     for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
  //     return buf;
  //   }
  //   fileSaver.saveAs(
  //     new Blob([s2ab(csv)], { type: "data:text/csv;charset=utf-8,${csv}`" }),
  //     "csvFilet.csv"
  //   );
  // };

  const exportToCSV = async () => {
    var obj = {};
    // arrayObject.map((it, ind) => {
    //   obj[it.headerValue] = stringToFunctionConverter(it?.value, 3);
    // });
    if (mapType == 3) {
      arrayObject.map((it, ind) => {
        obj[it.Header] = passthroughStringToFunctionConverter(
          it.PropertyName,
          sourceData,
          1
        );
      });
    } else {
      arrayObject.map((it, ind) => {
        obj[it.headerValue] = stringToFunctionConverter(it?.value, 3);
      });
    }
    const ws = XLSX.utils.json_to_sheet([obj], { origin: content });
    const csv = XLSX.utils.sheet_to_csv(ws, {
      strip: true,
      FS: ",",
      blankcolumns: true,
    });
    const blob = new Blob([csv], { type: "text/plain;charset=UTF-8" });
    fileSaver.saveAs(blob, `${stringToFunctionConverter(fileName, 2)}.csv`);
  };

  // function exportToText() {
  //   var obj = {};
  //   var abc = arrayObject.map((itm) => {
  //     return (itm = {
  //       ...itm,
  //       value: itm.headerValue == "First Name" ? itm.value.trim() : itm.value,
  //     });
  //   });
  //   const fileData = JSON.stringify(abc);
  //   const blob = new Blob([fileData], { type: "text/plain;charset=utf-8" });
  //   const url = URL.createObjectURL(blob);
  //   const link = document.createElement("a");
  //   link.download = "textFile".concat(".txt");
  //   link.href = url;
  //   link.click();
  // }

  return (
    <div>
      <LoaderWrapper>
        <div className="d-flex justify-content-end mb-3">
          {/* <CSVLink data={[objForCSV]} filename="bsedata.csv"  header>
            <FontAwesomeIcon
              icon={faCloudDownload}
              color="#333333"
              className="mr-3 ft-20 clickable"
              //  onClick={exportToExcel}
            />
          </CSVLink> */}

          <FontAwesomeIcon
            icon={faCloudDownload}
            color="#333333"
            className="mr-3 ft-20 clickable"
            onClick={fileFormat == 1 ? exportToCSV : exportToExcel}
          />

          {/* <FontAwesomeIcon
            icon={faSearch}
            color="#777777"
            className="bold ft-20 clickable"
          /> */}
        </div>
        <div className="mb-3">
          {/* <div className="bold ft-14">
            {stringToFunctionConverter(fileName, 2)}{fileFormatExtenstion}
          </div> */}
          <p>
            {stringToFunctionConverter(fileName, 2)}
            {fileFormatExtenstion}
          </p>
          <small>{arrayObject.length} Field(s)</small>
        </div>

        <ScrollTable
          header={arrayObject.map((item) => {
            return mapType == 3 ? item.Header : item.headerValue ?? "NULL";
          })}
          body={arrayObject.map((item) => {
            return mapType == 3
              ? passthroughStringToFunctionConverter(
                  item.PropertyName == "/TRANSFORMATION"
                    ? removePassthroughFieldTrans(item.ValueTransformations[0])
                    : item.PropertyName,
                  sourceData,
                  1
                )?.toString() ?? "NULL"
              : stringToFunctionConverter(item.value, 0)?.toString() ?? "NULL";
          })}
        ></ScrollTable>
      </LoaderWrapper>
    </div>
  );
};

export default VerifyMapExcelOutputContainer;
